/**
 * @description auto add suffix to starling key in runtime according to the region parameter
 * @author wuyan.geass
 */

import {
  PARTNER_REGION_MAP,
  PartnerRegion,
  SUFFIX_CHECK_ALLOWLIST,
} from './constants';

export interface MultiCountryProps {
  region?: string;
}

export enum AvailableRegion {
  US = 'us',
  ID = 'id',
  JP = 'jp',
}

export const RegionParamMap = {
  affiliate: 'shop_region',
  partner: 'market',
};

export const getRegion = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const keyword = Object.keys(RegionParamMap).find(key =>
    window.location.hostname.includes(key),
  );
  if (keyword) {
    const regionParam =
      keyword && keyword in RegionParamMap
        ? RegionParamMap[keyword as keyof typeof RegionParamMap]
        : '';
    const region =
      regionParam === 'market'
        ? PARTNER_REGION_MAP[
            (urlParams.get(regionParam) ??
              PartnerRegion.PartnerRegion_UNSPECIFIED) as PartnerRegion
          ]?.toLowerCase()
        : urlParams.get(regionParam)?.toLowerCase();
    return region;
  }
  return '';
};

let _region = getRegion();

export const multiCountryPlugin = {
  type: 'postProcessor' as const,
  name: 'MultiCountry',
  process(
    value: string,
    key: string[],
    options: Record<string, string>,
    translator: any,
  ) {
    // if handled, return value directly
    if (
      options?.isCountryHandled ||
      !_region ||
      SUFFIX_CHECK_ALLOWLIST.includes(Array.isArray(key) ? key[0] : key) ||
      !Object.values(AvailableRegion).map(String).includes(_region)
    ) {
      return value;
    }
    const suffix = `_${_region}`;
    const keyWithSuffix = (Array.isArray(key) ? key[0] : key) + suffix;

    if (translator.exists(keyWithSuffix)) {
      return translator.translate(
        keyWithSuffix,
        {
          ...options,
          defaultValue: undefined,
          isCountryHandled: true,
        },
        key,
      );
    }
    return value;
  },
};

export const updateMultiCountryRegion = (val: string) => {
  _region = val;
};
